<template>
  <div>
    <div :id="buttonId" :class="buttonClass">
      <i class="fa fa-info-circle fa-1x"></i> Banner Guidelines
    </div>
    <b-popover :target="buttonId" triggers="hover" placement="bottom">
      <ul>
        <li><b>Aspect Ratio: </b>5:1 (cropper comes preset)</li>
        <li><b>Preferred Size: </b>1920 x 384 pixels</li>
        <li><b>Preferred Type: </b>PNG, JPG</li>
        <li><b>Notes: </b>
          <ul>
            <li>Resize and move the cropper around</li>
            <li>Zoom by scrolling your mouse</li>
          </ul>
        </li>
      </ul>
    </b-popover>
  </div>
</template>

<script>
export default {
  name: 'BannerGuidelinesButton',
  props: {
    buttonClass: {
      type: String,
      default: 'btn btn-outline-info btn-md'
    },
    buttonId: {
      type: String,
      required: true
    }
  }
}
</script>
